/**
 * Central place for reading runtime configuration out of `import.meta.env`.
 * Keeping this as one module (instead of reading `import.meta.env.VITE_*`
 * all over the codebase) means there's a single spot to update if the app
 * ever needs config injected at container-start time instead of build time.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api",
  isDev: import.meta.env.DEV,
} as const;
